import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { mapLanguageToComponentProps } from 'careers/i18n'
import FeedbackPulse from 'components/feedback-pulse'
import { logEvent, EVENT_ACTIONS } from 'actions/audit-trail'
import ThirdPartyScripts from 'careers/components/third-party-scripts'
import { Flex } from 'components/styled/containers/flex'
import { Body, H3 } from 'components/styled/typography'
import { PositionType } from 'types'
import { I18nComponentType } from 'careers/i18n-types'
import { PageContent } from 'components/styled/page/page-content'

interface JobAdThankYouProps {
  company: { _id: string }
  i18n: I18nComponentType
  dispatch: any
  jobAd: PositionType
  applicationEmail?: string
}

const mapStateToProps = (state: any) => ({
  company: state.careers.company,
  applicationEmail: state.application.email,
  jobAd: state.jobAd,
})

export function JobAdThankYou({
  company,
  i18n,
  dispatch,
  jobAd,
  applicationEmail,
}: JobAdThankYouProps) {
  useEffect(() => {
    dispatch(
      logEvent({
        ec: company._id,
        ea: EVENT_ACTIONS.jobAdThankYouView,
      })
    )
  }, [])

  return (
    <PageContent size="small">
      <Flex mt="s48" flexDirection="column" alignItems="center">
        <H3 textAlign="center">{i18n.jobAdGreetings.thankYou}</H3>
        <Body textAlign="center">{i18n.jobAdGreetings.readyInfo}</Body>
        <Body textAlign="center">{i18n.jobAdGreetings.luck}</Body>
        {applicationEmail && (
          <FeedbackPulse position={jobAd} company={company} context="jobAd" />
        )}
        <ThirdPartyScripts />
      </Flex>
    </PageContent>
  )
}

export default connect(mapLanguageToComponentProps(mapStateToProps))(
  JobAdThankYou
)
